import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import HeaderDash from "../../Components/Admin/HeaderDash/HeaderDash";
import SinPermisos from "../../Components/SinPermisos/SinPermisos";
import { fetchUsuario, getUsuario } from "../../Components/user";

// este sería tu “data component” (como TiendaData)
import SucursalesData from "../../Components/Admin/SucursalesData/SucursalesData";

export default function Sucursales() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await fetchUsuario();
      setLoading(false);
    };
    fetchData();
  }, []);

  const usuarioLegued = getUsuario();

  return (
    <div className="containerGrid">
      <Header />

      <section className="containerSection">
        <HeaderDash />

        <div className="container">
          {loading ? (
            <></>
          ) : usuarioLegued?.idUsuario ? (
            <>
              {usuarioLegued?.rol === "admin" ? (
                <SucursalesData />
              ) : (
                <SinPermisos />
              )}
            </>
          ) : (
            <SucursalesData />
          )}
        </div>
      </section>
    </div>
  );
}
